import { legacyColors } from '~/legacyTheme';

const colors = {
  tab: {
    background: {
      default: legacyColors.grey2,
      disabled: legacyColors.grey2,
      active: legacyColors.white,
    },
    topBorder: {
      default: legacyColors.grey2,
      summary: legacyColors.grey6,
      disabled: legacyColors.grey2,
      active: legacyColors.blue,
    },
    text: {
      default: legacyColors.text.default,
      disabled: legacyColors.text.default,
      active: legacyColors.text.highlight,
    },
  },
};

export const useSxStyles = () => {
  return {
    content: {
      height: 'calc(100% - 33px)',
      border: `solid 1px ${legacyColors.grey4}`,
      backgroundColor: colors.tab.background.active,
    },
    tabs: {
      display: 'flex',
      padding: 0,
      margin: 0,
    },
    tab: {
      display: 'inline-flex',
      position: 'relative',
      padding: 0,
      width: 'auto',
    },
    tabButton: {
      marginLeft: '12px',
    },
    tabLink: {
      background: legacyColors.white1,
      display: 'block',
      padding: '0.5em 0.6em',
      border: 'none',
      borderRight: `1px solid #cccccc`,
      color: colors.tab.text.default,
      textDecoration: 'none',
      lineHeight: '1.3em',
      '&:hover': {
        backgroundColor: '#ededed',
        color: '#2b2b2b',
      },
      '&.active:hover, &.active': {
        background: 'none',
        color: legacyColors.blue,
      },
      '&[aria-disabled="true"]': {
        borderTopColor: colors.tab.topBorder.disabled,
        backgroundColor: colors.tab.background.disabled,
        color: colors.tab.text.disabled,
        pointerEvents: 'none',
        opacity: 0.5,
      },
    },
    tabLinkButton: {
      width: '20px',
      height: '20px',
      border: '1px solid #ccc',
      color: '#05A4D8',
      background: '#fff',
      textAlign: 'center',
      borderRadius: '3px',
      padding: 0,
      '&:hover': {
        border: '1px solid #fff',
        color: '#fff',
        background: '#05A4D8',
      },
    },
  };
};
